module.exports = __webpack_public_path__ + "img/C2QB_green_btn_tall_default_2x.86be9a5a.png";